namespace TabAurous.Finance {
    export interface PaymentForm {
        TransId: Serenity.IntegerEditor;
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        LedgerId: Serenity.LookupEditor;
        LedgerName: Serenity.StringEditor;
        TaxId: Serenity.LookupEditor;
        Rate: Serenity.DecimalEditor;
        TaxLedgerId: Serenity.IntegerEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchangeRate: Serenity.DecimalEditor;
        EnteredBy: Serenity.LookupEditor;
        UserId: Serenity.LookupEditor;
        RefNo: Serenity.StringEditor;
        RefDate: Serenity.DateEditor;
        Details: PaymentDetailsEditor;
        PartyBalance: PartyBalanceEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        TdsTotal: Serenity.DecimalEditor;
        KnockOffTotal: Serenity.DecimalEditor;
        TotalAmount: Serenity.DecimalEditor;
        Narration: Serenity.StringEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class PaymentForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.Payment';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PaymentForm.init)  {
                PaymentForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.StringEditor;
                var w3 = s.LookupEditor;
                var w4 = s.DecimalEditor;
                var w5 = PaymentDetailsEditor;
                var w6 = PartyBalanceEditor;

                Q.initFormType(PaymentForm, [
                    'TransId', w0,
                    'TransDate', w1,
                    'VoucherNo', w2,
                    'LedgerId', w3,
                    'LedgerName', w2,
                    'TaxId', w3,
                    'Rate', w4,
                    'TaxLedgerId', w0,
                    'CurrencyId', w3,
                    'ExchangeRate', w4,
                    'EnteredBy', w3,
                    'UserId', w3,
                    'RefNo', w2,
                    'RefDate', w1,
                    'Details', w5,
                    'PartyBalance', w6,
                    'VoucherTypeId', w0,
                    'TdsTotal', w4,
                    'KnockOffTotal', w4,
                    'TotalAmount', w4,
                    'Narration', w2,
                    'CompanyId', w0,
                    'FinancialYearId', w0
                ]);
            }
        }
    }
}
